import { BrowserModule } from "@angular/platform-browser";
import { inject, NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatToolbarModule } from "@angular/material/toolbar";
import { SearchModule } from "./search/search.module";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { AuthModule } from "./auth/auth.module";
import { MatButtonModule } from "@angular/material/button";
import { SystemDetailModule } from "./system-detail/system-detail.module";
import { SystemResolver } from "./resolver/system.resolver";
import { provideApollo } from "apollo-angular";
import { HttpLink } from "apollo-angular/http";
import { InMemoryCache } from "@apollo/client/core";
import { environment } from "../environments/environment";

const uri = environment.graphqlUrl;
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    SearchModule,
    AuthModule,
    MatButtonModule,
    SystemDetailModule,
  ],
  providers: [
    SystemResolver,
    provideHttpClient(withInterceptorsFromDi()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      return {
        link: httpLink.create({ uri }),
        cache: new InMemoryCache(),
      };
    }),
  ],
})
export class AppModule {}
